import $ from "jquery";
import 'sumoselect';
import './components/_filters';
import './ajax/ajax-filters';

$(document).ready(function(){

    var parentsSelectSelector = '.select-w';

    var containerSelector = '[js-conditional-select]';

    var containerConditional = $(containerSelector);

    var selectboxes = containerConditional.find('select');

    const liveContainer = $("[js-filter-list]");


    let options = {};


    const init = function (){

        //Prevent sending on Enter
        $('form input').keydown(function (e) {
            if (e.keyCode == 13) {
                $('#search-input').trigger("change");
                $('#search-input').blur();
                return false;
            }
        });

        //hide unselected to start un prepare options
        if(selectboxes) {

            let initialValue = {};

            selectboxes.each(function(index){
                var jThis = $(this);

                //store options
                options[jThis.attr('name')] = [];

                jThis.find('option').each(function() {
                    let option = $(this);
                    options[jThis.attr('name')].push(option);
                });

                //clean and hide unselected drodown
                if(index && !jThis.val()) {
                    jThis.parents(parentsSelectSelector).hide();
                    jThis.empty();
                }
                //store initial values
                if(jThis.val()) {
                    initialValue[jThis.attr('name')] = jThis.val();
                }

                //add trigger but last
                if(index < selectboxes.length - 1) {
                    jThis.on("change", function () {
                        manageChange(jThis);
                    });

                }

            });

            //trigger selected dropdown on load
            if(initialValue){
                for(let name in initialValue) {
                    let value = initialValue[name];
                    let select = containerConditional.find('select[name="'+ name +'"]');
                    select.val(value).trigger('change');

                }
            }
        }
    }

    const manageChange = function(target) {

        const selectedOption = target.find("option:selected");

        target.trigger("livesearch.filterChange");

        selectboxes.each(function(index){
            let select = $(this);

            if(!index || target.attr('name') == select.attr('name')) {
                return;
            }
            select.empty();
            //fill options
            for(let i in options[select.attr('name')]){
                var option = options[select.attr('name')][i];
                if(option.data('parent') == selectedOption.data('id') || !option.attr('value')) {
                    select.append(option);
                }
            }


            let optionsLinked = select.find('option[data-parent="'+ selectedOption.data('id') +'"]');

            let parent = select.parents(parentsSelectSelector);
            if(optionsLinked.length){
                parent.show();
                select.val('');
            }
            else{
                parent.hide();
            }
            if( select[0].sumo){
                select[0].sumo.reload();
            }
          //


        });
    };


    init();

});